export default "__VITE_ASSET__CuWIQSem__"